import sanityClient from '@sanity/client';

export const client = sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-01-13',
  token: process.env.REACT_APP_SANITY_TOKEN,
});
